import FornecedorTelefoneService from "@/services/FornecedorTelefoneService";

export const fornecedorTelefone = {
  namespaced: true,
  state: {
    fornecedorTelefone: {},
  },
  actions: {
    getFornecedorTelefone({ commit }, payload) {
      return FornecedorTelefoneService.GetFornecedorTelefone(payload).then(
        (fornecedorTelefone) => {
          return Promise.resolve(fornecedorTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postFornecedorTelefone({ commit }, payload) {
      return FornecedorTelefoneService.PostFornecedorTelefone(payload).then(
        (fornecedorTelefone) => {
          return Promise.resolve(fornecedorTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putFornecedorTelefone({ commit }, payload) {
      return FornecedorTelefoneService.PutFornecedorTelefone(payload).then(
        (fornecedorTelefone) => {
          return Promise.resolve(fornecedorTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteFornecedorTelefone({ commit }, payload) {
      return FornecedorTelefoneService.DeleteFornecedorTelefone(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getFornecedorTelefoneOData({ commit }, payload) {
      return FornecedorTelefoneService.GetFornecedorTelefoneOData(payload).then(
        (fornecedorTelefone) => {
          return Promise.resolve(fornecedorTelefone);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default fornecedorTelefone;
